import TransactionHistory from './TransactionHistory';

export default TransactionHistory;
